export const APP_STATUS = "APP_STATUS";
export const ACTIVAR_LOADING = "ACTIVAR_LOADING";
export const CARGAR_RAES = "CARGAR_RAES";
